<script>
import {useThemeStore} from "@js/store/ThemeStore.js";
import IconX from "@js/components/Icons/IconX.vue";

export default {
    name: "Toast",
    components: {IconX},
    setup() {
        const themeStore = useThemeStore()

        let touchStartY = 0
        let touchEndY = 0

        const handleTouchStart = (event) => {
            touchStartY = event.touches[0].clientY
        }

        const handleTouchEnd = (event, id) => {
            touchEndY = event.changedTouches[0].clientY
            if (touchStartY - touchEndY > 50) {
                themeStore.removeToast(id)
            }
        }

        return {themeStore, handleTouchStart, handleTouchEnd};
    }
}
</script>

<template>
    <div class="fixed top-5 right-5 z-50 flex flex-col">
        <TransitionGroup name="fade" tag="div">
            <div role="alert" v-for="(data, key) in themeStore.toasts" :key="data.id"
                 @click.prevent="themeStore.removeToast(data.id)"
                 @touchstart="handleTouchStart"
                 @touchend="(event) => handleTouchEnd(event, data.id)"
                 :class="{
                'bg-emerald-600': data.type === 'success',
                'bg-red-600': data.type === 'error'
                }"
                 class="relative flex items-center w-full max-w-xs px-10 py-4 space-x-4 text-white divide-gray-300 rounded-lg shadow mb-2">
                <div class="text-sm font-medium">{{ data.message }}</div>
<!--                <div class="group absolute top-1 right-1 cursor-pointer">-->
<!--                    <IconX class="w-5 h-5 stroke-white hover-group:stroke-indigo-600 transition"/>-->
<!--                </div>-->
            </div>
        </TransitionGroup>
    </div>
</template>

<style scoped lang="scss">
/* Анимация появления и исчезновения */
.fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter-from, .fade-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}
</style>
